export default {
  offerAddedToWishlist: 'offer-added-to-wishlist',
  offerRemovedFromWishlist: 'offer-removed-from-wishlist',
  offerClicked: 'offer-clicked',
  offerAlertCreated: 'offer-alert-created',
  offerUnpublished: 'offer-unpublished',
  filtersApplied: 'filters-applied',
  pageViewed: 'page-viewed',
  searchVisited: 'search-visited',
  sortChanged: 'sort-changed',
  noResults: 'no-results',
  newSearchResultsRetrieved: 'new-search-results-retrieved',
  newResidencesSearchResultsRetrieved: 'new-residences-search-results-retrieved',
  whiteLabelLead: 'white-label-lead',
  propertyOffersAddedToWishlist: 'property-offers-added-to-wishlist',
  propertyOffersRemovedFromWishlist: 'property-offers-removed-from-wishlist',
  faqOpened: 'faq-opened',
  searchBarClicked: 'search-bar-clicked',
  searchResHomepage: 'search-res-homepage',
  newSearchResults: 'new-search-results-summary',
  trackLogin: 'login-track',
  trackSignup: 'signup-track',
  trackSignupErrors: 'signup-errors',
  openCalendar: 'calendar-opened',
  allFeatures: 'all-features-modal',
  aboutThisRoom: 'about-this-room-modal',
  rentalConditions: 'rental-conditions-modal',
  selectedDates: 'selected-dates',
  bookNowResidences: 'book-now-residences',
  showMorePhotos: 'show-more-photos',
  uniTrustClicked: 'uni-trust-clicked',
  verificationCodeRequested: 'verification-code-requested',
  verificationCodeResend: 'verification-code-resend',
  guestAuthenticationStatusDimension: 'guest-authentication-status-dimension',
  offerCardClicked: 'offer-card-clicked',
  cityClicked: 'city-clicked',
  trackSignupCompleted: 'signup-completed',
  viewSignupPage: 'view-signup-page',
  signupTabChanged: 'signup-tab-changed',
  searchResultsSummary: 'search-results-summary',
  extraGuestAdded: 'extra-guests-added',
  priceReview: 'price-review',
  datesApplied: 'dates-applied',
  visitUnpublishedListing: 'visit-unpublished-listing'
};
